/* eslint-disable react/require-default-props */
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import React from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Img,
} from './styles';
import color from '../../constants/color';

interface Props {
  expanded: boolean;
  setOpen: Function;
  icon: string;
  title: string;
  component?: JSX.Element;
}

const Expansion: React.FC<Props> = ({
  expanded, setOpen, icon, title, component,
}) => (
  <Accordion expanded={expanded} onChange={() => setOpen(!expanded)}>
    <AccordionSummary
      style={{ borderWidth: 1, borderBottom: `1px solid ${color.grey5}` }}
      expandIcon={<ExpandMoreIcon />}
      aria-controls="panel1a-content"
      id="panel1a-header"
    >
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
        <Img height={34} width={34} src={icon} />
        <div style={{
          fontFamily: 'Inter',
          color: '#686775',
          marginLeft: 17,
          fontSize: 14,
        }}
        >
          {title}
        </div>
      </div>
    </AccordionSummary>
    <AccordionDetails>
      {component}
    </AccordionDetails>
  </Accordion>
);
export default Expansion;
